import {
  TypedUseSelectorHook,
  useSelector as useAppSelector,
} from "react-redux";
import type { RootState } from "../redux";
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;
export default useSelector;
